import { createFileRoute } from "@tanstack/react-router";
import { HomeLandingPage } from "@/features/landing/HomeLandingPage";

export const Route = createFileRoute("/home/")({
  component: HomeLandingPage,
  head: () => ({
    meta: [
      {
        title: "FlowState Automate — AI-Powered Business Automation",
      },
      {
        name: "description",
        content:
          "FlowState Automate brings CRM, AI agents, tasks, accounting, and calendar into one connected workspace. Start free.",
      },
    ],
  }),
});
